// components/ModelDropdown.js
import { faCaretDown, faRobot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Button } from '@quyva/shared-ui'; // Update this import based on your actual Dropdown component path
import { toSentenceCase } from '@quyva/common';
const ModelDropdown = ({
    modelTierRepo,
    visionModel,
    isLoadingModels,
    setModelTierRepo,
    setVisionModel,
    availableCustomModels,
    ModelTiers,
    isAdmin,
}) => {
    const handleModelChange = (tier, model = null) => {
        setModelTierRepo(tier);
        setVisionModel(model);
    };

    const buildCategorizedCustomModelSubmenuItems = (
        categorizedModels,
        modelTier,
        handleModelChangeFn
    ) => {
        const submenuItems = [];
        let isFirstCategory = true;
        const sortedCategories = Object.keys(categorizedModels).sort();

        for (const category of sortedCategories) {
            const models = categorizedModels[category];
            if (models?.length > 0) {
                if (!isFirstCategory) submenuItems.push({ isDivider: true });

                submenuItems.push({ label: category, isHeading: true });

                models.forEach((modelName) => {
                    submenuItems.push({
                        label: modelName,
                        action: () => handleModelChangeFn(modelTier, modelName),
                    });
                });

                isFirstCategory = false;
            }
        }

        return submenuItems.length > 0
            ? submenuItems
            : [
                  {
                      label: 'No custom models available',
                      disabled: true,
                      action: () => {},
                  },
              ];
    };

    const modelsForUser = isAdmin
        ? availableCustomModels
        : Object.fromEntries(
            Object.entries(availableCustomModels || {}).filter(([key]) =>
                key === 'Gemini' || key === 'OpenAI'
            )
        );

    const customSubmenuModelItems = buildCategorizedCustomModelSubmenuItems(
        modelsForUser,
        ModelTiers.CUSTOM,
        handleModelChange
    );

    const modelDropdownItems = [
        {
            label: toSentenceCase(ModelTiers.STANDARD),
            action: () => handleModelChange(ModelTiers.STANDARD),
        },
        {
            label: toSentenceCase(ModelTiers.PRECISION),
            action: () => handleModelChange(ModelTiers.PRECISION),
        },
        {
            label: toSentenceCase(ModelTiers.CUSTOM),
            isSubmenu: true,
            items: customSubmenuModelItems,
        },
    ];

    return (
        <Dropdown
            dropDownList={modelDropdownItems}
            showButtonText={true}
            buttonText={
                isLoadingModels
                    ? 'Loading...'
                    : modelTierRepo === ModelTiers.CUSTOM && visionModel
                    ? visionModel
                    : modelTierRepo
            }
            buttonHoverText={'Select Model Used'}
            buttonClassName={'w-[250px]'}
            listTitleText={'Select Model'}
            placement={'right'}
        />
    );
};

export default ModelDropdown;
